import React, { useRef, useState } from 'react';
import api from '../api';
import { collectionStatus } from '../utils/collectionPresentation';
import WarehouseShipmentPanel from './WarehouseShipmentPanel';
import '../pages/collectorCollection.css';

export default function CollectorCollectionTask({ order, reload }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const active = useRef(false);
  const path = `/api/collector/orders/${order.id}`;
  const { collection } = order;

  const act = async (request) => {
    if (active.current) return;
    active.current = true;
    setBusy(true);
    setError('');
    try {
      await request();
    } catch (err) {
      const message = err.response?.data?.error;
      setError(typeof message === 'string' ? message : 'Действие не выполнено. Повторите попытку.');
    } finally {
      await reload();
      active.current = false;
      setBusy(false);
    }
  };

  const receipt = (item, quantity) => act(() => api.put(`${path}/items/${item.id}/receipt`, {
    quantity, expectedQuantity: item.collectedQuantity,
  }));

  return (
    <article className="collector-task" aria-labelledby={`collector-task-${order.id}`}>
      <h3 id={`collector-task-${order.id}`}>Заказ №{order.id}</h3>
      <p className="collector-task-status" role="status">
        {collectionStatus(order)} · получено позиций {collection.collected} из {collection.total}
      </p>
      {order.sellerOrders.map(seller => (
        <fieldset key={seller.id}>
          <legend>{seller.seller?.name || `Продавец №${seller.sellerId}`}</legend>
          {seller.collectionPoint && <p><strong>Где забрать</strong> {seller.collectionPoint}</p>}
          <ul>
            {seller.items.map(item => {
              const { product, variant } = item.orderItem || {};
              const received = item.collectedQuantity;
              const title = product?.title || `Позиция №${item.id}`;
              const variantText = [product?.color, variant?.size].filter(Boolean).join(' · ');
              return (
                <li key={item.id}>
                  <strong>{title}</strong>
                  <p>{variantText && `${variantText} · `}{item.quantity} шт.</p>
                  <p className="collector-task-status">
                    {received == null ? 'Ожидает получения' : received === 0 ? 'Нет в наличии' : `Получено ${received} из ${item.quantity}`}
                  </p>
                  {collection.canCollect && received !== item.quantity && (
                    <>
                      <div className="collector-task-actions">
                        <button className="btn btn-primary" disabled={busy} aria-label={`Забрал: ${title}`}
                          onClick={() => receipt(item, item.quantity)}>Забрал</button>
                        {received !== 0 && <button className="btn btn-outline" disabled={busy}
                          onClick={() => receipt(item, 0)}>Нет товара</button>}
                      </div>
                      {item.quantity > 1 && (
                        <details>
                          <summary>Получил часть</summary>
                          <form className="collector-task-actions" onSubmit={(event) => {
                            event.preventDefault();
                            receipt(item, Number(new FormData(event.currentTarget).get('quantity')));
                          }}>
                            <label>Количество <input name="quantity" required type="number" inputMode="numeric" min="1" max={item.quantity - 1} /></label>
                            <button className="btn btn-outline" disabled={busy}>Сохранить</button>
                          </form>
                        </details>
                      )}
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </fieldset>
      ))}
      {collection.dropoffAddress && <p><strong>Пункт сдачи</strong> {collection.dropoffAddress}</p>}
      <WarehouseShipmentPanel order={order} role="collector" />
      {busy && <p role="status">Сохраняем…</p>}
      {error && <p className="collector-task-error" role="alert">{error}</p>}
    </article>
  );
}
